<template>
  <reset-password :settings="settings" />
</template>

<script>
import ResetPassword from '../../components/ResetPassword.vue';

export default {
  name: 'UpdatePassword',

  components: {
    ResetPassword,
  },

  computed: {
    settings() {
      return this.$store.state.partners.currentPartner.settings.sections
        .reset_password_page.reset_password;
    },
  },
};
</script>
